import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Td,
  ModalHeader,
  ModalOverlay,
  useColorModeValue,
  Center,
  Spinner
  // Select,
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FC, useEffect, useState } from 'react'
import { BiSliderAlt } from 'react-icons/bi'

import useReabRoutes from '@hook/parametrization/use-reab-routes'
import useAuth from '@hook/shared/use-auth'

import LayoutToolsButton from '@component/Layout/Tools/Actions/Components/Button'

const ModalHistoricRouteReab: FC = () => {
  const { companies: authCompanies } = useAuth()

  const [isOpen, setIsOpen] = useState(false)
  const { getHistoric, loadingHistoric, historic, companieId } = useReabRoutes()

  const colorSpinner = useColorModeValue('black', 'white')
  const handleClose = () => {
    setIsOpen(false)
  }

  const handleOpen = () => {
    setIsOpen(true)
  }

  useEffect(() => {
    if (isOpen) {
      getHistoric(companieId === '' ? authCompanies[0] : companieId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  return (
    <>
      <LayoutToolsButton
        isDisabledDefault={companieId === ''}
        label="Historico"
        onClick={handleOpen}
      />

      <Modal isOpen={isOpen} onClose={handleClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Histórico modificação Rotas
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody bg="white">
            <Box overflowX="auto" maxHeight={490}>
              {loadingHistoric ? (
                <>
                  <Box h={40}>
                    <Center pt={10}>
                      <Flex
                        direction="column"
                        alignItems="center"
                        textAlign="center"
                      >
                        <Spinner
                          thickness="4px"
                          speed="0.65s"
                          emptyColor="gray.200"
                          color={colorSpinner}
                          size="xl"
                        />
                        <Text
                          color={colorSpinner}
                          marginTop="4"
                          fontSize="xl"
                          fontWeight="bold"
                        >
                          Buscando dados
                        </Text>
                      </Flex>
                    </Center>
                  </Box>
                </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr bg="gray.200">
                        <Th color="black" bg="gray.200">
                          Data
                        </Th>
                        <Th color="black">Usuario</Th>
                        <Th color="black">Empresa</Th>

                        <Th color="black">Acao</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflowY="auto">
                      {historic.map((item: any) => (
                        <Tr>
                          <Td>
                            {' '}
                            {dayjs(item.dataAcao).format('DD/MM/YYYY hh:mm:ss')}
                          </Td>
                          <Td>{item.usuario} </Td>
                          <Td>{item.empresaId}</Td>

                          <Td>{item.acao}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </>
              )}
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ModalHistoricRouteReab
